import { render, staticRenderFns } from "./RealtimeList.vue?vue&type=template&id=670d0141&scoped=true&"
import script from "./RealtimeList.vue?vue&type=script&lang=js&"
export * from "./RealtimeList.vue?vue&type=script&lang=js&"
import style0 from "./RealtimeList.vue?vue&type=style&index=0&id=670d0141&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670d0141",
  null
  
)

export default component.exports